<template>
    <div>
        <v-container fluid>
            <v-banner single-line sticky>
                <v-row>
                    <v-col cols="12" class="text-right">
                        <v-btn
                            rounded
                            small
                            class="primary--text"
                            @click="open_newcase_eeg()"
                        >
                            NEW CASE EEG
                        </v-btn>
                    </v-col>
                </v-row>
                <v-alert
                    color="blue-grey darken-3"
                    dense
                    border="bottom"
                    type="primary"
                    icon="mdi-information"
                >
                    <v-row no-gutters>
                        <v-col cols="4"
                            >OPEN NEW CASE {{ showCase.case_id }}</v-col
                        >
                        <v-col v-if="showCase.case_id == ''" cols="4">
                            <span class="text-color-red"
                                >Last Update : {{ Last_update }}</span
                            >
                        </v-col>
                        <v-col cols="4" class="text-center">
                            <v-chip
                                v-if="showproject != ''"
                                class="orange darken-2"
                                dark
                            >
                                <h3 class="ma-3">{{ showproject }}</h3>
                            </v-chip>
                        </v-col>
                        <v-col cols="4" class="text-right">
                            <v-btn
                                v-if="visible"
                                class="ma-2"
                                @click="back()"
                                tile
                                color="cyan darken-1"
                                dark
                                >Back</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-alert>
            </v-banner>

            <div v-if="!visible">
                <v-row>
                    <v-col cols="8" sm="4">
                        <v-textarea
                            v-model="findData"
                            auto-grow
                            outlined
                            rows="5"
                            row-height="25"
                            rounded
                            solo
                        ></v-textarea>
                    </v-col>
                    <v-col cols="4" sm="2">
                        <v-btn
                            :loading="loading"
                            :disabled="loading"
                            color="blue-grey"
                            class="white--text"
                            fab
                            @click="findCase()"
                        >
                            <!-- @click="loader = 'loading'" -->
                            <v-icon dark>mdi-cloud-search-outline</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="8" sm="4">
                        <v-file-input
                            v-model="files"
                            color="blue darken-4"
                            counter
                            label="อัพโหลดงาน SRFR"
                            multiple
                            small-chips
                            placeholder="Select your files"
                            prepend-icon="mdi-paperclip"
                            :show-size="1000"
                        ></v-file-input>
                    </v-col>
                    <v-col cols="4" sm="2">
                        <v-btn
                            :loading="loading2"
                            :disabled="loading2"
                            color="blue-grey"
                            class="white--text"
                            fab
                            @click="UploadFiles()"
                        >
                            <v-icon dark>mdi-file-upload-outline</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="4" sm="4">
                        <view-alert :alert="alert" v-if="alert.status" />
                    </v-col>
                </v-row>
                <table-view-case
                    v-if="visibleduplicate"
                    :condition="condition"
                    :data_case="data_new"
                    :casetab="casetab"
                />
                <v-row>
                    <v-col :cols="12" v-if="data_case.total > 0">
                        <v-alert
                            dense
                            border="bottom"
                            type="primary"
                            icon="mdi-information"
                            >CASE TODAY</v-alert
                        >
                        <table-view-case
                            :casetab="casetab"
                            :condition="condition"
                            :data_case="data_case"
                        />
                        <div class="text-center pa-5">
                            <v-pagination
                                @input="onPageChange"
                                v-model="pagination.current"
                                :length="data_case.last_page"
                                circle
                            ></v-pagination>
                        </div>
                    </v-col>
                </v-row>
            </div>
            <div v-if="!visiblecase">
                <v-card>
                    <v-form ref="form" v-model="information.valid">
                        <v-information
                            :condition="condition"
                            :information="information"
                        />
                        <!-- <case-information
              :condition="condition"
              :information="information"
            />
            <product-information
              :condition="condition"
              :information="information"
            />
            <customer-information
              :condition="condition"
              :information="information"
            /> -->
                        <engineer-information
                            @showform="validateform()"
                            :condition="condition"
                            :information="information"
                        />
                        <part-information
                            :condition="condition"
                            :information="information"
                        />
                    </v-form>
                    <!-- <log-information
                        :condition="condition"
                        :information="information"
          />-->
                    <!-- <v-row justify="center">
                        <v-checkbox
                            v-if="condition.team != 'NONHP'"
                            v-model="information.kci"
                            false-value="N"
                            true-value="Y"
                            label="ข้ามขั้นตอน KCI หรือไม่?"
                        ></v-checkbox>
                    </v-row> -->

                    <v-row justify="center">
                        <v-col cols="10" md="4" class="text-center">
                            <v-checkbox
                                v-if="condition.team != 'NONHP'"
                                v-model="information.kci"
                                false-value="N"
                                true-value="Y"
                                label="ข้ามขั้นตอน KCI หรือไม่?"
                            ></v-checkbox>
                        </v-col>
                        <!-- /// {{ information.skip_ismart }} /// -->
                        <v-col cols="10" md="4" class="text-center">
                            <v-checkbox
                                v-if="condition.team != 'NONHP'"
                                v-model="information.skip_ismart"
                                false-value="N"
                                true-value="Y"
                                label="ช่างไม่ต้องปิด EEG"
                            ></v-checkbox>
                        </v-col>
                    </v-row>

                    <v-row justify="center">
                        <v-col
                            cols="12"
                            class="text-center"
                            v-if="vali_chk_save != ''"
                        >
                            <span style="color: red">{{ vali_chk_save }}</span>
                        </v-col>
                        <v-col cols="8" v-if="chk_save_new == true">
                            <v-progress-linear
                                class="ma-10"
                                indeterminate
                                color="cyan"
                            ></v-progress-linear>
                        </v-col>
                        <v-col
                            cols="12"
                            class="text-center"
                            v-if="chk_save_new == false"
                        >
                            <v-btn
                                @click="saveCase()"
                                class="ma-4 mar-t-20"
                                tile
                                color="success"
                            >
                                <v-icon left>mdi-content-save</v-icon>Save
                            </v-btn>
                        </v-col>

                        <!-- <v-btn class="ma-4" tile color="warning">
              <v-icon left>mdi-close-octagon</v-icon>Cancel
            </v-btn>-->
                    </v-row>
                </v-card>
            </div>
        </v-container>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-row justify="center">
            <v-dialog v-model="dialog_eeg" persistent max-width="800px">
                <v-card>
                    <v-card-title>
                        <span class="text-h5">
                            CASE UPDATE :
                            <span class="red--text">
                                {{ data_eeg_last }}
                            </span>
                            <v-btn
                                fab
                                x-small
                                class="ml-1"
                                @click="get_newcase_eeg()"
                            >
                                <v-icon color="primary">mdi-refresh</v-icon>
                            </v-btn>
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="dialog_eeg = false"
                        >
                            Close
                        </v-btn>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <v-simple-table class="table-inv">
                                    <template v-slot:default>
                                        <thead>
                                            <tr class="col-tr-1">
                                                <th class="text-center">#</th>
                                                <th class="text-center">
                                                    Case ID
                                                </th>
                                                <th class="text-center">WO</th>
                                                <th class="text-center">
                                                    Update At
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr
                                                v-for="(row, index) in data_eeg"
                                                :key="index"
                                            >
                                                <td class="text-center">
                                                    {{ index + 1 }}.
                                                </td>
                                                <td class="text-center">
                                                    {{ row.caseid }}
                                                </td>
                                                <td class="text-center">
                                                    {{ row.wonumber }}
                                                </td>
                                                <td class="text-center">
                                                    {{ row.dateupload }}
                                                </td>
                                            </tr>
                                            <br />
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>

                        <!-- <small>*indicates required field</small> -->
                    </v-card-text>
                    <v-card-actions>
                        <!-- <v-spacer></v-spacer>
                        <v-btn
                            color="blue darken-1"
                            text
                            @click="dialog_eeg = false"
                        >
                            Close
                        </v-btn> -->
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import axios from "axios"
import firebaseApp from "../../../firebase"

import { mapState, mapMutations } from "vuex"

import TableViewCase from "../components/TableViewCase"
import CaseInformation from "../components/CaseInformation"
import ProductInformation from "../components/ProductInformation"
import CustomerInformation from "../components/CustomerInformation"
import EngineerInformation from "../components/EngineerInformation"
import PartInformation from "../components/HpiPartInformation"
import LogInformation from "../components/LogInformation"
import ViewAlert from "../components/ShowAlert"

import EngineerNewInformation from "../components/EngineerNewInformation"
import Information from "../components/Information"
export default {
    components: {
        "table-view-case": TableViewCase,
        "case-information": CaseInformation,
        "customer-information": CustomerInformation,
        "product-information": ProductInformation,
        "engineer-information": EngineerNewInformation,
        "part-information": PartInformation,
        "log-information": LogInformation,
        "view-alert": ViewAlert,
        "v-information": Information,
    },
    computed: {
        ...mapState(["isLoading"]),
    },
    data() {
        return {
            dialog_loading: false,
            dialog_eeg: false,
            data_eeg_last: "",
            data_eeg: [],
            chk_save_new: false,
            casetab: false,
            vali_chk_save: "",
            data: {},
            information: {},
            defaultInformation: {
                case_title: "",
                case_type: "",
                case_problem_type: "",
                case_sla: "",
                case_sla_date: "",
                case_sla_time: "",
                remark: "",
                subcase_title: "",
                customer_name: "",
                customer_tel: "",
                customer_email: "",
                site_name: "",
                site_address: "",
                site_postcode: "",
                site_district_id: "",
                site_amphur_id: "",
                site_province_id: "",
                log_type: "",
                log_note: "",
                product_group: "",
                sms_language: "",
                sms_status: "",
                str: "",
                product_line: "",
                product_no: "",
                product_serial: "",
                product_description: "",
                branch_id: "",
                engineer: "",
                part: [],
            },
            condition: {
                team: "BKK",
                status: "ViewDetail",
                project: "",
            },
            findData: "",
            findDetail: {
                case_id: "",
                ponumber: "",
                wonumber: "",
            },
            showproject: "",
            showCase: {
                case_id: "",
            },
            information: {},
            loader: null,
            loading: false,
            loading2: false,
            files: [],
            data_case: [],
            pagination: {
                current: 1,
            },
            visiblecase: true,
            visible: false,
            alert: {
                text: "",
                status: false,
            },
            visibleduplicate: false,
            data_new: [],
            Last_update: "",
        }
    },
    mounted() {
        this.getOwnerTodayCase()
        this.getLastUpdate()
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        // onFileSelected(event) {
        //   for (let i = 0; i < event.length; i++) {
        //     this.files.push(event[i]);
        //   }
        // },
        open_newcase_eeg() {
            this.dialog_eeg = true
            this.get_newcase_eeg()
        },
        async get_newcase_eeg() {
            this.dialog_loading = true
            await axios
                .get(`${process.env.VUE_APP_ROOT_API}/api/newcase`, this.tk)
                .then((response) => {
                    this.data_eeg_last = response.data[0].dateupload
                    this.data_eeg = response.data
                    this.dialog_loading = false
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        validateform() {
            this.$refs.form.validate()
        },
        onPageChange() {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            })
            this.getOwnerTodayCase()
        },
        getOwnerTodayCase: _.debounce(async function(e) {
            this.visibleduplicate = false
            this.casetab = false
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/owner-case-today?page=${this.pagination.current}`
            try {
                const { data } = await axios.get(`${url}`, options)
                this.pagination.current = data.current_page
                this.data_case = data
                this.casetab = true
            } catch (error) {
                console.log(error)
            }
        }, 1000),
        async saveCase() {
            // -- Start EEG --
            // this.information.skip_ismart
            //     ? (this.information.skip_ismart = this.information.skip_ismart)
            //     : (this.information.skip_ismart = "Y")

            let check_status_part
            let project_name = this.showproject

            this.information.part.map((each) => {
                if (each.part_no == "") {
                    this.information.part = []
                } else if (each.status == "Back Order") {
                    check_status_part = "Back Order"
                }
            })
            this.information.project_name = project_name
            this.information.check_status_part = check_status_part

            let date = new Date()
            let year = date.toLocaleString("default", { year: "numeric" })
            let month = date.toLocaleString("default", { month: "2-digit" })
            let day = date.toLocaleString("default", { day: "2-digit" })
            var h = date.getHours()
            var m = date.getMinutes()
            var s = date.getSeconds()
            let formattedDate =
                year + "-" + month + "-" + day + "T" + h + ":" + m + ":" + s

            if (
                this.condition.team != "NONHP" &&
                this.information.skip_ismart != "Y"
            ) {
                if (this.information.check_status_part == "Back Order") {
                    let Partner_Parts_Hold = {
                        CaseExchange: {
                            EventType: "PartnerUpdates",
                            EventSubType: "Updates",
                            Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                            IncomingChannel: "EEG",

                            WorkOrder: {
                                WorkOrderID: this.information.wonumber,
                                PartnerName: "APJ_Acacia_P",
                                PartnerStatus: "Partner Parts Hold",
                                PartnerStatusDateTime: this.cal_date_eegX(
                                    "main",
                                    ""
                                ),
                            },
                            Notes: {
                                NotesDescription: "$#Part Waiting#$",
                                ExternallyVisible: "Yes",
                            },
                        },
                    }

                    this.information.eeg = {
                        Partner_Parts_Hold: Partner_Parts_Hold,
                    }
                }
            }

            if (
                this.condition.team != "NONHP" &&
                this.information.skip_ismart != "Y"
            ) {
                this.information.skip_ismart = "N"
                this.information.RequestedDateTime = this.data.RequestedDateTime
                this.information.GuaranteedFixTime = this.data.GuaranteedFixTime

                let datax = {
                    CaseExchange: {
                        EventType: "PartnerUpdates",
                        EventSubType: "Updates",
                        Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                        IncomingChannel: "EEG",
                        WorkOrder: {
                            WorkOrderID: this.information.wonumber,
                            PartnerName: "APJ_Acacia_P",
                            PartnerStatusDateTime: this.cal_date_eegX(
                                "main",
                                ""
                            ),
                        },
                        Notes: {
                            NotesDescription: null,
                            ExternallyVisible: "Yes",
                        },
                        Attachment: {
                            FileType: null,
                            FileName: null,
                            FileContent: null,
                        },
                    },
                }
                this.information.eeg1 = {
                    Note_Update_All: datax,
                }
            }

            // -- END EEG --

            this.information.part.map((each) => {
                if (each.part_no == "") {
                    this.information.part = []
                }
            })
            if (this.information.engineer == "ZONE") {
                this.information.dateonsite = ""
            }
            this.information.case_sla_datetime =
                this.information.case_sla_date +
                " " +
                this.information.case_sla_time
            const url = `${process.env.VUE_APP_ROOT_API}/api/hp/newcase`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            try {
                let chk_save
                if (
                    this.information.case_type == "" ||
                    this.information.case_type == null ||
                    this.information.case_type == undefined
                ) {
                    this.vali_chk_save = "**กรุณาเลือก Case Type"
                    chk_save = false
                } else if (
                    this.information.warranty_type == "" ||
                    this.information.warranty_type == null ||
                    this.information.warranty_type == undefined
                ) {
                    this.vali_chk_save = "**กรุณาเลือก Warranty Type"
                    chk_save = false
                } else {
                    chk_save = true
                }

                // start sms
                if (this.information.sms_status == "Y") {
                    let str
                    if (this.information.sms_language == "th") {
                        str = `ขอบคุณที่ให้ทาง HP ได้ดูแลคุณ หมายเลขอ้างอิงงานซ่อมของคุณคือ ${this.information.case_id} เราจะติดต่อคุณอีกครั้งเพื่อทำการนัดหมายเป็นลำดับถัดไป สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`
                    } else if (this.information.sms_language == "en") {
                        str = `Thank you for choosing HP, Your case no: ${this.information.case_id} We will getting you back soon, if you have any queries, please contact 020781589`
                    }
                    let str_th = str
                    str = str
                        .split("")
                        .map((char) =>
                            addZeros(char.charCodeAt(0).toString(16))
                        )
                        .join("")
                    // console.log(str)
                    function addZeros(str) {
                        return ("0000" + str).slice(-4)
                    }
                    this.information.str = str
                    this.information.str_th = str_th
                    console.log(this.information, "-this.information")
                }

                if (chk_save == true) {
                    this.chk_save_new = true
                    this.mutateIsLoading()
                    let { data, status, statusText } = await axios
                        .post(url, this.information, options)
                        .catch(function(error) {
                            swal({
                                title: `Error Message : ${error}`,
                                icon: "error",
                                button: "OK",
                            })
                        })
                    this.chk_save_new = false
                    this.mutateIsLoading()
                    if (status == "200") {
                        this.$swal({
                            title: "บันทึกข้อมูลเรียบร้อย ?",
                            text: "",
                            icon: "success",
                            timer: 3000,
                        }).then((del) => {
                            this.visible = false
                            this.visiblecase = true
                            this.showproject = ""
                            this.showCase.case_id = ""
                            this.getOwnerTodayCase()
                            this.findData = ""
                        })
                    } else {
                        alert(statusText)
                    }
                }
            } catch (error) {
                console.log(error.message)
            }

            //   var contactRef = firebaseApp.database().ref(`contacts/${this.information.ReferCase}`)
            //   contactRef.set({
            //         casetitle: this.information.casetitle,
            //         jobtype: this.information.jobtype,
            //         proptype : this.information.Probtype
            //   })
        },
        back() {
            this.visible = false
            this.visiblecase = true
            this.showproject = ""
            this.showCase.case_id = ""
        },
        async findCase() {
            var data = this.findData.split("\n")

            this.findDetail.case_id = data[0].trim()
            this.findDetail.wonumber = data.length >= 2 ? data[1] : ""
            this.findDetail.ponumber = data.length == 3 ? data[2] : ""

            this.findDetail.type =
                this.findDetail.case_id[0] == "5" &&
                this.findDetail.case_id.length == 10 &&
                this.findDetail.case_id.substring(0, 2) != "53"
                    ? "CDAX"
                    : this.findDetail.case_id.substring(0, 2) == "53"
                    ? "HPE"
                    : "SRFR"

            try {
                const url = `${process.env.VUE_APP_ROOT_API}/api/hp/checkcase`
                const { data } = await axios.post(`${url}`, this.findDetail)
                // console.log(data)
                this.data = data
                // -- Start EEG --
                if (this.data.wonumber) {
                    this.findDetail.wonumber = this.data.wonumber
                }

                // -- END EEG --

                if (
                    this.data.error !== undefined &&
                    this.data.error != "manual"
                ) {
                    if (this.data.error == "duplicate case") {
                        var form = {
                            searchtext: this.findDetail.case_id,
                        }
                        const options = {
                            headers: {
                                Authorization: "Bearer " + localStorage.token,
                            },
                        }
                        const url = `${process.env.VUE_APP_ROOT_API}/api/allcase?page=1`

                        const { data } = await axios.post(
                            `${url}`,
                            form,
                            options
                        )
                        this.data_new = data
                        this.visibleduplicate = true
                    } else {
                        this.alert = {
                            text: this.data.error,
                            status: true,
                        }
                        this.showproject = ""
                    }
                } else if (
                    this.findDetail.type == "SRFR" &&
                    this.data.file == "ok"
                ) {
                    window.open(
                        `${process.env.VUE_APP_ROOT_API}/api/srfr/view-upload/${this.findDetail.case_id}/${localStorage.token}`
                    )
                } else {
                    this.alert = {
                        text: "",
                        status: false,
                    }
                    this.showproject =
                        this.findDetail.case_id[0] == "5" &&
                        this.findDetail.case_id.length == 10 &&
                        this.findDetail.case_id.substring(0, 2) != "53"
                            ? this.data.project_name
                            : this.findDetail.case_id.substring(0, 2) == "53"
                            ? "HPE"
                            : "SRFR"

                    this.condition.project = this.findDetail.type

                    this.visible = true
                    this.visiblecase = false
                    this.showCase.case_id =
                        this.data.hpi_cso != undefined &&
                        this.data.hpi_cso !== null &&
                        this.data.hpi_cso != ""
                            ? this.data.hpi_cso
                            : this.data.error == "manual"
                            ? this.findDetail.case_id
                            : this.data.caseid
                    // console.log(this.data.parts, " -this.data.parts")
                    this.information = {
                        wonumber: this.findDetail.wonumber,
                        case_type: "",
                        case_problem_type: "",
                        problem_type: [
                            {
                                problem_type_name: "Hardware",
                                problem_type_id: "4",
                            },
                            {
                                problem_type_name: "Software",
                                problem_type_id: "5",
                            },
                            {
                                problem_type_name: "Monitor",
                                problem_type_id: "13",
                            },
                        ],
                        case_sla: "",
                        case_sla_date: "",
                        case_sla_time: "",
                        remark:
                            this.data.remark != undefined
                                ? this.data.remark
                                : "",
                        subcase_title:
                            this.data.casetitle != undefined
                                ? this.data.casetitle
                                : "",
                        site_district_id: "",
                        site_amphur_id: "",
                        site_province_id: "",
                        log_type: "",
                        log_note: "",
                        product_description: "",
                        branch_id: "",
                        engineer: "",
                        case_id:
                            this.data.hpi_cso != undefined &&
                            this.data.hpi_cso !== null &&
                            this.data.hpi_cso != ""
                                ? this.data.hpi_cso
                                : this.data.error == "manual"
                                ? this.findDetail.case_id
                                : this.data.caseid,
                        case_title: this.data.casetitle,
                        customer_name:
                            this.data.firstname + " " + this.data.lastname,
                        customer_tel: this.data.tel,
                        customer_email: this.data.email,
                        site_name:
                            this.data.companyname === undefined
                                ? this.data.firstname + " " + this.data.lastname
                                : this.data.companyname,
                        site_address: this.data.address,
                        site_postcode:
                            this.data.postalcode != undefined &&
                            this.data.postalcode.length == "5"
                                ? this.data.postalcode + "x"
                                : "",
                        product_group: this.data.productgroup,
                        product_line: this.data.productline,
                        product_no: this.data.productno,
                        product_serial: this.data.serial,
                        product_description: this.data.productdescription,
                        part:
                            this.data.parts.length == 0
                                ? []
                                : [...this.data.parts],
                        otc_code: this.data.otc,
                        cdax_log: this.data.cdax_log,
                        warranty_type: null,
                        Instructions: this.data.Instructions, //  EEG
                        DmrFlag: this.data.DmrFlag ? this.data.DmrFlag : null, //  EEG
                        offer_part_no: this.data.offer_part_no
                            ? this.data.offer_part_no
                            : null, //  EEG
                        offer_part_desc: this.data.offer_part_desc
                            ? this.data.offer_part_desc
                            : this.data.offer_part_desc, //  EEG
                    }
                    // console.log(this.information, "-this.information ")
                }
            } catch (error) {
                console.log(error.message)
            }
        },
        async UploadFiles() {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                    "Content-Type": "multipart/form-data",
                },
            }

            try {
                let formData = new FormData()
                const url = `${process.env.VUE_APP_ROOT_API}/api/srfr/upload`

                if (undefined !== this.files && this.files.length > 0) {
                    for (let i = 0; i < this.files.length; i++) {
                        formData.append(`files[${i}]`, this.files[i])
                    }

                    const { data, status } = await axios.post(
                        url,
                        formData,
                        options
                    )

                    if (status == "200") {
                        swal({
                            title: "Upload Complete",
                            icon: "success",
                            button: "OK",
                        })

                        this.files = []
                    } else {
                        swal({
                            title: "Upload error",
                            icon: "error",
                            button: "OK",
                        })
                    }
                } else {
                    swal({
                        title: "กรุณาเลือกไฟล์ !!",
                        icon: "error",
                        button: "OK",
                    })
                }
            } catch (error) {
                console.log(error)
            }
        },
        async getLastUpdate() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/hp/last-updated`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const { data } = await axios.get(`${url}`, options)
            this.Last_update = data.last_updated
        },
        cal_date_eegX(st1, st2) {
            let date = new Date()
            var h = date.getHours()
            var m = date.getMinutes()
            var s = date.getSeconds()
            let year = date.toLocaleString("default", {
                year: "numeric",
            })
            let month = date.toLocaleString("default", {
                month: "2-digit",
            })
            let day = date.toLocaleString("default", { day: "2-digit" })

            if (st1 == "main") {
                let dateD = `${year}-${month}-${day}T${h}:${m}:${s}Z`
                let myArray = dateD.split(" ")
                let arr1 =
                    myArray.length == 1
                        ? myArray[0].split("-")
                        : myArray[1].split("-")
                let formattedDate =
                    myArray.length == 1
                        ? dateD
                        : `${arr1[0] - 543}-${arr1[1]}-${arr1[2]}`

                return formattedDate
            }
        },
    },
    watch: {
        loader() {
            const l = this.loader
            this[l] = !this[l]

            setTimeout(() => (this[l] = false), 3000)

            this.loader = null
        },
    },
}
</script>

<style>
.custom-loader {
    animation: loader 1s infinite;
    display: flex;
}
@-moz-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@-webkit-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@-o-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}

.v-banner__text {
    width: 1150px;
}
</style>
